import React, { FC, useMemo, useRef } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { CSSTransition } from "react-transition-group";
import { XHComponentCommonProps } from "../../types";
import Mask from "../Mask";
import Image from "../Image";

import "./index.scss";

export type ToastProps = {
  title: string;
  duration?: number;
  /** 图标
   * 可选值：
   * - 'success': 显示成功图标，此时 title 文本最多显示 7 个汉字长度;
   * - 'error': 显示失败图标，此时 title 文本最多显示 7 个汉字长度;
   * - 'loading': 显示加载图标，此时 title 文本最多显示 7 个汉字长度;
   * - 'none': 不显示图标，此时 title 文本最多可显示两行 */
  icon?: "success" | "error" | "loading" | "none";
  /** 自定义图标的本地路径，image 的优先级高于 icon */
  image?: string;
  /** 是否显示透明蒙层，防止触摸穿透 */
  mask?: boolean;
} & XHComponentCommonProps;

const ToastCom: FC<ToastProps> = props => {
  const { title, className = "", icon = "none", image = "" } = props;

  const toastcls = classNames("xh-toast", className);

  // icon-success_toast
  // icon-alert_toast
  // icon-failure_toast
  // icon-loading_toast

  const classConfig = {
    success: "icon-success_toast",
    error: "icon-failure_toast",
    loading: "icon-loading_toast",
    none: "",
  };
  const cls = classNames("iconfont", classConfig[icon]);
  const showIcon = useMemo(() => {
    if (image) return <Image src={image} width={24} height={24} />;
    if (icon) return <span className={cls}></span>;
  }, [icon, image]);

  const nodeRef = useRef(null);

  const DialogMain = (
    <View className={toastcls}>
      <Mask mask="transparent" />
      <CSSTransition
        nodeRef={nodeRef}
        in
        timeout={200}
        classNames="face"
        unmountOnExit
      >
        <View className="xh-toast-content">
          {showIcon}
          <View>{title}</View>
        </View>
      </CSSTransition>
    </View>
  );

  return ReactDOM.createPortal(DialogMain, document.body);
};

export default ToastCom;
